import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./auth";
import { api } from "./api";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
  const { company, updateCompany } = useAuth() || {};
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("operon_theme") || "dark";
  });

  useEffect(() => {
    const t = company?.theme || theme;
    const root = document.documentElement;
    root.classList.toggle("dark", t === "dark");
    localStorage.setItem("operon_theme", t);
    if (t !== theme) setTheme(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [company?.theme]);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("operon_theme", theme);
  }, [theme]);

  const toggleTheme = useCallback(async () => {
    const next = theme === "dark" ? "light" : "dark";
    setTheme(next);
    if (company) {
      try {
        await api.put("/settings", { theme: next });
        updateCompany?.({ theme: next });
      } catch {
        /* ignore */
      }
    }
  }, [theme, company, updateCompany]);

  return <ThemeCtx.Provider value={{ theme, setTheme, toggleTheme }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
